module.exports = __webpack_public_path__ + "static/media/sobre-atendimento-bg.2e450719.jpg";